import { SpotifyApi } from "@spotify/web-api-ts-sdk";

const CLIENT_ID = import.meta.env.VITE_SPOTIFY_CLIENT_ID;
const REDIRECT_URI = import.meta.env.VITE_SPOTIFY_REDIRECT_URI;

if (!CLIENT_ID || !REDIRECT_URI) {
  throw new Error("Spotify client ID or redirect URI is not defined in environment variables.");
}

const SCOPES = [
  "user-read-private",
  "user-read-email",
  "playlist-read-private",
  "user-library-read",
  "user-modify-playback-state",
  "user-read-playback-state",
  "streaming",
  "user-read-recently-played",
  "playlist-modify-public",
  "playlist-modify-private",
  "user-top-read",
  "user-library-modify",
];

export const spotifyApi = SpotifyApi.withUserAuthorization(CLIENT_ID, REDIRECT_URI, SCOPES);

export const isTokenExpired = (token: string) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

export const createPlaylist = async (name: string, description?: string) => {
  const user = await spotifyApi.currentUser.profile();
  return spotifyApi.playlists.createPlaylist(user.id, {
    name,
    description,
    public: false,
  });
};

export const addTracksToPlaylist = async (playlistId: string, trackUris: string[]) => {
  return spotifyApi.playlists.addItemsToPlaylist(playlistId, trackUris);
};

export const removeTracksFromPlaylist = async (playlistId: string, trackUris: string[]) => {
  return spotifyApi.playlists.removeItemsFromPlaylist(playlistId, {
    tracks: trackUris.map((uri) => ({ uri })),
  });
};
